module.exports = __webpack_public_path__ + "static/media/csv.06668368.svg";